import { apicall } from "../../../services/api";
import { Toastify } from "../../../services/toastify/toastifyContainer";
import { AI_ACTION_TYPES } from "../actions_ai_type";

export const headerAi = (data) => async (dispatch) => {
  try {
    const res = await apicall(`bbps/create-header`, "post", data);
    if (res.status === 201 && res.data.success === true) {
      dispatch({
        type: AI_ACTION_TYPES.CREATE_AI_HEADER_SECTION_LOADED,
        payload: res?.data,
      });
      localStorage.setItem("isHeaderCreated", true);
      Toastify({ data: "success", msg: res?.data?.message });
      return res.data;
    } else if (res.status === 201 && res.data.success === false) {
      Toastify({ data: "error", msg: res?.data?.message });
      return res.data;
    }
  } catch (err) {
    console.log(err, "err1");
    if (err?.response?.status === 409) {
      Toastify({ data: "error", msg: err?.response?.data?.msg });
    } else {
      Toastify({ data: "error", msg: err?.response?.data?.message });
    }
  }
};

export const bodyAi = (data) => async (dispatch) => {
  try {
    const res = await apicall(`bbps/create-body`, "post", data);
    if (res.status === 201 && res.data.success === true) {
      dispatch({
        type: AI_ACTION_TYPES.CREATE_AT_BODY_SECTION_LOADED,
        payload: res?.data,
      });
      localStorage.setItem("isBodyCreated", true);
      Toastify({ data: "success", msg: res?.data?.message });
      return res?.data;
    } else if (res.status === 201 && res.data.success === false) {
      Toastify({ data: "error", msg: res?.data?.message });
      return res.data;
    }
  } catch (error) {
    console.log(error);
    if (error?.response?.status === 409) {
      Toastify({ data: "error", msg: error?.response?.data?.msg });
    } else if (error?.response?.status === 400) {
      Toastify({ data: "error", msg: error?.response?.data?.message });
    } else if (
      error?.response?.status === 500 &&
      error?.response?.data?.msg?.includes("duplicate key value")
    ) {
      Toastify({
        data: "error",
        msg: "Body already exists with this agent id",
      });
    } else {
      Toastify({ data: "error", msg: error?.response?.data?.message });
    }
  }
};

export const footerAi = (data) => async (dispatch) => {
  try {
    const res = await apicall(`bbps/create-footer`, "post", data);
    if (res.status === 201 && res.data.success === true) {
      dispatch({
        type: AI_ACTION_TYPES.CREATE_AT_FOOTER_SECTION_LOADED,
        payload: res?.data,
      });
      localStorage.setItem("isFooterCreated", true);
      Toastify({ data: "success", msg: res?.data?.message });
      return res?.data;
    } else if (res.status === 201 && res.data.success === false) {
      Toastify({ data: "error", msg: res?.data?.message });
      return res.data;
    }
  } catch (error) {
    console.log(error);
    if (error?.response?.status === 409) {
      Toastify({ data: "error", msg: error?.response?.data?.msg });
    } else if (error?.response?.status === 400) {
      Toastify({ data: "error", msg: error?.response?.data?.message });
    } else if (
      error?.response?.status === 500 &&
      error?.response?.data?.msg?.includes("duplicate key value")
    ) {
      Toastify({
        data: "error",
        msg: "Footer already exists with this agent id",
      });
    } else {
      Toastify({ data: "error", msg: error?.response?.data?.message });
    }
  }
};

// create agent
export const createAgent = (data) => async (dispatch) => {
  try {
    const res = await apicall(`agent/create`, "POST", data);
    if ((res.status = 201)) {
      dispatch({
        type: AI_ACTION_TYPES.GET_CREATED_AGENT_RESPONSE,
        paylod: res?.data?.data,
      });
      Toastify({ data: "success", msg: res?.data?.message });
      dispatch(getAllAiAgentDetails());
      return res?.data?.data;
    }
  } catch (error) {
    console.error(error, "error");
    if (error?.response?.status === 409) {
      Toastify({ data: "error", msg: error?.response?.data?.msg });
    } else {
      Toastify({ data: "error", msg: error?.response?.data?.message });
    }
  }
};

// ai assign campaign
export const assignCampaign = (data) => async (dispatch) => {
  try {
    const res = await apicall(`ai_assign_campaign/assign`, "POST", data);
    // if (res.status === 201) {
    dispatch({
      type: AI_ACTION_TYPES.ASSIGN_CAMPAIGN,
      payload: res?.data?.data,
    });
    Toastify({ data: "success", msg: res?.data?.message });
    dispatch(updateAiAssignCampaignInVMS(data));
    dispatch(getAllAiAssignedCampaigns());
    return res?.data?.data;
    // }
  } catch (error) {
    console.error(error, "error");
    Toastify({ data: "error", msg: error?.response?.data?.message });
  }
};

// bbps/getParticularforupdate/:agent_id/:name   GET -- get one for update

export const getHeaderData = (data) => async (dispatch) => {
  try {
    const response = await apicall(
      `bbps/getParticularforupdate/${data.agent_id}/${data.name}`,
      "GET"
    );
    if (response) {
      dispatch({
        type: AI_ACTION_TYPES.GET_HEADER_DATA_FOR_PARTICULAR,
        payload: response.data.data?.data,
      });
      return response.data.data;
    }
  } catch (error) {
    console.log(error);
  }
};

// get body data
export const getBodyData = (data) => async (dispatch) => {
  try {
    const response = await apicall(
      `bbps/getParticularforupdate/${data?.agent_id}/${data?.name}`,
      "GET"
    );
    if (response) {
      dispatch({
        type: AI_ACTION_TYPES.GET_BODY_DATA_FOR_PARTICULAR,
        payload: response.data.data?.data,
      });
      return response?.data?.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getFooterData = (data) => async (dispatch) => {
  try {
    const response = await apicall(
      `bbps/getParticularforupdate/${data?.agent_id}/${data?.name}`,
      "GET"
    );
    if (response) {
      dispatch({
        type: AI_ACTION_TYPES.GET_FOOTER_DATA_FOR_PARTICULAR,
        payload: response?.data?.data?.data,
      });
      return response?.data?.data;
    }
  } catch (error) {
    console.log(error);
  }
};

// bbps/detail/:agent_id  GET -- Get all together
export const getAiDataByAgentID = (agentId) => async (dispatch) => {
  try {
    const res = await apicall(`bbps/detail/${agentId}`, "GET");
    if (res) {
      dispatch({
        type: AI_ACTION_TYPES.GET_AI_DATA_BY_AGENT_ID,
        payload: res?.data?.data,
      });

      return res?.data?.data;
    }
  } catch (error) {
    console.log(error);
  }
};

// bbps/getAll
export const getAllAiData = () => async (dispatch) => {
  try {
    const res = await apicall(`bbps/getAll`, "GET");
    if (res) {
      dispatch({
        type: AI_ACTION_TYPES.GET_ALL_AI_DATA,
        payload: res?.data?.data,
      });
      return res?.data?.data;
    }
  } catch (error) {
    console.error(error);
    Toastify({ data: "error", msg: error?.response?.message });
  }
};

// get all agent details
export const getAllAiAgentDetails = () => async (dispatch) => {
  try {
    const res = await apicall(`agent/getAgentDetails`, "GET");
    if (res) {
      dispatch({
        type: AI_ACTION_TYPES.GET_ALL_AGENT_DETAILS,
        payload: res?.data?.data,
      });
      return res?.data?.data;
    }
  } catch (error) {
    console.error(error);
    // Toastify({ data: "error", msg: error?.response?.data?.msg });
  }
};

// get all unassigned campaign from vms for ai-saas
export const getUnAssignedCampaigns = () => async (dispatch) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_BASE_URL_VMS}ai/campaigns/all`,
      {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    const response = await res.json();
    if (response?.success) {
      dispatch({
        type: AI_ACTION_TYPES.GET_UNASSIGNED_CAMPAIGNS,
        payload: response?.data,
      });
    }
  } catch (error) {
    console.error(error);
    Toastify({ data: "error", msg: error?.response?.data?.message });
  }
};

// get assigned compaigns
export const getAllAiAssignedCampaigns = () => async (dispatch) => {
  try {
    const res = await apicall(`ai_assign_campaign/getassignedDetail`, "GET");
    if (res) {
      dispatch({
        type: AI_ACTION_TYPES.GET_ASSIGNED_CAMPAIGNS,
        payload: res?.data?.data,
      });
      return res?.data?.data;
    }
  } catch (error) {
    console.error(error);
    Toastify({ data: "error", msg: error?.response?.data?.message });
  }
};

// get ai agent details by id
export const getAiAgentById = (id) => async (dispatch) => {
  try {
    const res = await apicall(`agent/${id}`, "GET");
    if (res) {
      dispatch({
        type: AI_ACTION_TYPES.GET_AI_AGENT_DATA_BY_ID,
        payload: res?.data?.data,
      });
      return res?.data?.data;
    }
  } catch (error) {
    console.error(error);
    Toastify({ data: "error", msg: error?.response?.data?.message });
  }
};

// check data structure for ai_id
export const checkDataStructureByAiId = (id) => async (dispatch) => {
  try {
    const res = await apicall(`bbps/checkagentStructure/${id}`, "GET");
    if (res) {
      dispatch({
        type: AI_ACTION_TYPES.CHECK_DATA_STRUCTURE_BY_AI_ID,
        payload: res?.data,
      });
      dispatch({
        type: AI_ACTION_TYPES.ONGOING_AGENTID,
        payload: id,
      });
      if (
        res?.data?.data?.header === true &&
        res?.data?.data?.body === true &&
        res?.data?.data?.footer === true
      ) {
        Toastify({
          data: "success",
          msg: "Structure is already created for this ai_id",
        });
      }
      localStorage.removeItem("updatingAgentId");
      return res;
    }
  } catch (error) {
    console.error(error);
  }
};

// update header data
export const updateHeaderAi = (data) => async (dispatch) => {
  try {
    const res = await apicall(
      `bbps/update-header/${data.agent_id}`,
      "patch",
      data
    );
    if (res.status === 200 && res.data.success === true) {
      dispatch({
        type: AI_ACTION_TYPES.UPDATE_AI_HEADER_DATA_SECTION,
        payload: res?.data,
      });
      localStorage.setItem("isHeaderUpdated", true);
      Toastify({ data: "success", msg: res?.data?.message });
      dispatch(getAllAiData())
      return res;
    } else if (res.status === 200 && res.data.success === false) {
      Toastify({ data: "error", msg: res?.data?.message });
      return res.data;
    }
  } catch (err) {
    console.log(err, "err1");
    Toastify({ data: "error", msg: err?.response?.data?.message });
  }
};

export const updateBodyAi = (data) => async (dispatch) => {
  try {
    const res = await apicall(
      `bbps/update-body/${data.agent_id}`,
      "patch",
      data
    );
    if (res.status === 200 && res.data.success === true) {
      dispatch({
        type: AI_ACTION_TYPES.UPDATE_AI_BODY_DATA_SECTION,
        payload: res?.data,
      });
      localStorage.setItem("isBodyUpdated", true);
      Toastify({ data: "success", msg: res?.data?.message });
      dispatch(getAllAiData())
      return res;
    } else if (res.status === 200 && res.data.success === false) {
      Toastify({ data: "error", msg: res?.data?.message });
      return res.data;
    }
  } catch (err) {
    console.log(err);
    Toastify({ data: "error", msg: err?.response?.data?.message });
  }
};

export const updateFooterAi = (data) => async (dispatch) => {
  try {
    const res = await apicall(
      `bbps/update-footer/${data.agent_id}`,
      "patch",
      data
    );
    if (res.status === 200 && res.data.success === true) {
      dispatch({
        type: AI_ACTION_TYPES.UPDATE_AI_FOOTER_DATA_SECTION,
        payload: res?.data,
      });
      localStorage.setItem("isFooterUpdated", true);
      Toastify({ data: "success", msg: res?.data?.message });
      localStorage.removeItem("updatingAgentId");
      dispatch(getAllAiData())
      return res;
    } else if (res.status === 200 && res.data.success === false) {
      Toastify({ data: "error", msg: res?.data?.message });
      return res.data;
    }
  } catch (err) {
    console.log(err);
    Toastify({ data: "error", msg: err?.response?.data?.message });
  }
};

// update agent by ai_id
export const updateAgentById = (data) => async (dispatch) => {
  try {
    const res = await apicall(
      `agent/${data.updatingAgentId}`,
      "patch",
      data.recreatedSchema
    );
    dispatch({
      type: AI_ACTION_TYPES.UPDATE_AI_AGENT,
      payload: res,
    });
    if (res.status === 200) {
      Toastify({ data: "success", msg: res?.data?.message });
    } else {
      Toastify({ data: "success", msg: res?.data?.message });
    }
    dispatch(getAllAiAgentDetails());
  } catch (error) {
    console.log(error);
    Toastify({ data: "error", msg: error?.response?.data?.msg });
  }
};

// update campaign by id
export const updateAssignedCampaignById = (id) => async (dispatch) => {
  try {
    const res = await apicall(`ai_assign_campaign/${id}`, "patch");
    dispatch({
      type: AI_ACTION_TYPES.UPDATE_AI_ASSIGNED_CAMPAIGN_BY_ID,
      payload: res,
    });
    if (res.status === 200) {
      Toastify({ data: "success", msg: res?.data?.message });
    } else {
      Toastify({ data: "success", msg: res?.data?.message });
    }
    dispatch(getAllAiAssignedCampaigns());
  } catch (error) {
    console.log(error);
    Toastify({ data: "error", msg: error?.response?.data?.msg });
  }
};

// update unassigned campaigns by updating ai saas campaign
export const updateAiAssignCampaignInVMS = (data) => async (dispatch) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_BASE_URL_VMS}ai/campaigns/ai_id`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(data),
      }
    );
    if (res) {
      dispatch({
        type: AI_ACTION_TYPES.UPDATE_ASSIGNED_CAMPAIGN_IN_VMS,
        payload: res?.data,
      });
    }
  } catch (error) {
    console.error(error);
  }
};

// delete by agent id
export const deleteById = (id) => async (dispatch) => {
  try {
    const res = await apicall(`bbps/${id}`, "DELETE");
    if (res.data?.data === true) {
      dispatch({
        type: AI_ACTION_TYPES.DELETE_AI_DATA,
        payload: res,
      });
      Toastify({ data: "success", msg: "deleted" });
      dispatch(getAllAiData);
    }
    return res;
  } catch (error) {
    console.log(error);
    Toastify({ data: "error", msg: error?.response?.data?.message });
  }
};

// delete a created agent by ai_id
export const deleteAgentById = (id) => async (dispatch) => {
  try {
    const res = await apicall(`agent/${id}`, "DELETE");
    if (res.data?.data === true) {
      dispatch({
        type: AI_ACTION_TYPES.DELETE_AGENT_AI,
        payload: res,
      });
      Toastify({ data: "success", msg: "deleted" });
      dispatch(getAllAiAgentDetails());
    }
    return res;
  } catch (error) {
    console.log(error);
    Toastify({ data: "error", msg: "already deleted" });
  }
};

// delete a assigned campaign by campaign id
export const deleteAssignedCampaignById = (id) => async (dispatch) => {
  try {
    const res = await apicall(`ai_assign_campaign/${id}`, "DELETE");
    if (res.data?.data === true) {
      dispatch({
        type: AI_ACTION_TYPES.DELETE_CAMPAIGN_BY_ID,
        payload: res,
      });
      Toastify({ data: "success", msg: res?.data?.message });
    }
    dispatch(getAllAiAssignedCampaigns());
    return res;
  } catch (error) {
    console.log(error);
    Toastify({ data: "error", msg: error?.response?.data?.msg });
  }
};
